import { Apps, ArrowBack, NavigateNext, ViewList } from '@mui/icons-material';
import { Box, Breadcrumbs, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { DishVariation, OrderItem } from '../../../apiTypes';
import { t } from '../../../constants/translations';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';
import CategoriesList from './CategoriesList';
import Dishes from './DishesList';
import SectionsList from './SectionsList';

type Props = {
  onAdd: (id: string, variadion?: DishVariation) => void;
  items: OrderItem[];
};

const Menu = ({ onAdd, items }: Props) => {
  const menuView = window.localStorage.getItem('menuView');
  const { lang } = useLocale();
  const { sectionsMap, categoriesMap } = useCafe();
  const [sectionId, setSectionId] = useState<string | null>(null);
  const [categoryId, setCategoryId] = useState<string | null>(null);
  const [isList, setIsList] = useState(menuView === 'list');

  const handleBack = () => {
    if (categoryId) {
      setCategoryId(null);
      return;
    }
    setSectionId(null);
  };

  const handleChangeView = (view: 'list' | 'grid') => {
    window.localStorage.setItem('menuView', view);
    setIsList(view === 'list');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          top: 0,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {sectionId && (
            <Box sx={{ width: 48, height: 48, mr: 1 }}>
              <IconButton onClick={handleBack} size="large">
                <ArrowBack />
              </IconButton>
            </Box>
          )}

          {!sectionId && (
            <Typography sx={{ ml: 2, py: 1 }} color={(t) => t.palette.text.secondary} variant="h6" component="p">
              {t.menu[lang]}
            </Typography>
          )}
          <Breadcrumbs separator={<NavigateNext fontSize="small" />}>
            {sectionId && (
              <Typography
                variant="subtitle1"
                onClick={() => setCategoryId(null)}
                sx={{ a: { cursor: 'pointer', textDecoration: 'none', color: (t) => t.palette.text.primary } }}
              >
                {sectionsMap[sectionId]?.name}
              </Typography>
            )}

            {categoryId && <Typography variant="subtitle1">{categoriesMap[categoryId]?.name}</Typography>}
          </Breadcrumbs>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton disabled={isList} onClick={() => handleChangeView('list')}>
            <ViewList />
          </IconButton>
          <IconButton disabled={!isList} onClick={() => handleChangeView('grid')}>
            <Apps />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ overflow: 'auto' }}>
        {!sectionId && <SectionsList selectSection={(id) => setSectionId(id)} isList={isList} />}
        {sectionId && !categoryId && (
          <CategoriesList sectionId={sectionId} selectCategory={(id) => setCategoryId(id)} isList={isList} />
        )}
        {sectionId && categoryId && <Dishes onAdd={onAdd} categoryId={categoryId} items={items} isList={isList} />}
      </Box>
    </Box>
  );
};

export default Menu;
